import { FilterByDate } from '../../../../types/types';
import DateRangePickerUi from '../../../DateRangePickerUi/DateRangePickerUi';
import { getDateString } from '../../../../utils/filters/getDateString';
import { FilterData } from '../../../FilterForm/FilterForm';

interface IFilterDateRangeProps {
  onChange: (filterData: FilterData) => void;
  filter: FilterByDate;
  filterData?: FilterData;
}

export default function FilterDateRange({
  filter,
  filterData,
  onChange,
}: IFilterDateRangeProps) {
  let from, to;
  if (filterData?.values) {
    from = filterData?.values[0] ? new Date(filterData?.values[0]) : null;
    to = filterData?.values[1] ? new Date(filterData?.values[1]) : null;
  }

  const handleRangeSet = (newRange, namedRange) => {
    const fromString: any = newRange.from ? getDateString(newRange.from) : null;
    const toString: any = newRange.to ? getDateString(newRange.to) : null;
    onChange({
      id: filter.id,
      values: [fromString, toString],
      namedRange,
    });
  };

  return (
    <DateRangePickerUi
      from={from}
      to={to}
      handleRangeSet={handleRangeSet}
      namedRange={filterData?.namedRange}
      defaultValue={filter.defaultValue || null}
      defaultNamedRange={filter.defaultNamedRange || null}
      minValue={filter.minValue ? new Date(filter.minValue) : null}
      maxValue={filter.maxValue ? new Date(filter.maxValue) : null}
    />
  );
}
